module.exports = __webpack_public_path__ + "static/media/press06.87aa604b.png";